export default class RouterHelper {
	static install(Vue, options) {
		Vue.routerHelper = Vue.prototype.$routerHelper = {
			lastPushed: null
		};
		Vue.mixin({
			methods: {
				push(route = {route: '/'}) {
					this.$routerHelper.lastPushed = this.$options.name;
					this.$router.push(route);
				}
			}
		});
	}
}